import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from '../../contexts/auth';
import notify from 'devextreme/ui/notify';
import { useNavigate, useParams } from 'react-router-dom';
import {adminGetCompanies, updateAPIReportData} from '../../api/api'
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { DataGrid, Column, Paging, } from 'devextreme-react/data-grid';
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import './hse.scss';

export default function SIFUpload() {
  const navigate = useNavigate();
  let { year, company_id } = useParams();
  const fileInputRef = useRef();
  const { user, refreshSession } = useAuth();
  const [originalData, setOriginalData] = useState(null);
  const [companiesList, setCompaniesList] = useState([]);
  const [yearsList, setYearsList] = useState([]);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [currentYear, setCurrentYear] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const onCompanySelected = useCallback((e) => {
    setOriginalData(null);
    for (var i=0; i<companiesList.length; i++){
      if (companiesList[i].company_id === e.value) {
        setCurrentCompany(companiesList[i]);
      }
    }
  }, [companiesList])

  const onGetCompaniesSuccess = useCallback((data) => {
    data = data.sort((a,b) => (a.company_name > b.company_name) ? 1 : ((b.company_name > a.company_name) ? -1 : 0))
    setCompaniesList(data);
    if (yearsList.length === 0) {
      const currentYear = new Date().getFullYear();
      for (var i=2023; i<currentYear; i++) {
        yearsList.push(i.toString())
      }
      setYearsList([...yearsList]);
    }
    if (year) {
      setCurrentYear(year.toString());
    }
    if (company_id) {
      onCompanySelected({value:company_id});
    }
    setLoading(false);
  }, [setCompaniesList, setLoading, yearsList, setYearsList, company_id, year])

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      console.log(error);
      setLoading(false);
    }
  }, [refreshSession]);

  useEffect(() => {
    if (user.signInUserSession) {
      let groups = user.signInUserSession.idToken.payload['cognito:groups']
      var has_perm=false;
      if (groups) {
        for (var i=0; i<groups.length; i++) {
          if (groups[i]==='admin') {
            has_perm=true;
            setIsAdmin(true);
            adminGetCompanies(user, onGetCompaniesSuccess, onError);
            break;
          }
        }
      }
      if (!has_perm) {
        notify("Insufficient permissions. Please contact the system administrator.", 'error', 5000);
        navigate('/home');
        return
      }

    }
  }, [user, navigate, onError, onGetCompaniesSuccess]);

  const readClipboard = useCallback(async () => {
    var lncnt = 0;
    try {
      const text = await navigator.clipboard.readText();
      var line_delimiter = '\n';
      if (text.includes('\r\n')) {
        line_delimiter = '\r\n';
        console.log("line delimiter is rn");
      } else {
        console.log("line delimiter is n");
      }
      const lines = text.split(line_delimiter);
      const array = [];
      const first_line = [];
      for (const line of lines) {
        lncnt=lncnt+1;
        const values = line.split('\t');
        console.log(values);
        if (values[1] === "") {
          continue;
        }
        if (first_line.length === 0) {
          if ((values[1] !== "Identifier") && (values[1] !== "ID")) {
            continue;
          }
          if (values[1] === "ID") {
            values[1] = "Identifier"
          }
          first_line.push(...values);
          console.log(first_line);
          continue;
        }
        if (parseInt(values[1]).toString() !== values[1]) {
          continue;
        }
        console.log(values);
        var el = {}
        for (var i=0; i<values.length; i++){
          if (!first_line[i]) {
            continue;
          }
          if (first_line[i].length === 0) {
            continue;
          }
          if (values[i].length > 0) {
            values[i] = values[i].replaceAll("\"","");
          }
          if (values[i] === "SELECT") {
            values[i]=null;
          }
          if (values[i] === "NR") {
            values[i]=null;
          }
          var intVal = parseInt(first_line[i])
          if ((intVal>2000) && (intVal<2100)) {
            el["year_"+first_line[i]]=values[i];
          } else {
            el[first_line[i]]=values[i];
          }
        }
        //Handle microsoft BS
        if (values.length===1) {
          if (values[0]==='') {
            continue
          }
        }
        array.push(el);
      }
      //console.log(array);
      setOriginalData(array);
    } catch (err) {
      notify("Failed to read clipboard contents. Error at row: "+lncnt.toString(), 'error', 2000);
      console.error('Failed to read clipboard contents: ', err);
    }
  }, [user, navigate, onError, onGetCompaniesSuccess]);

  const onYearSelected = useCallback((e) => {
    setOriginalData(null);
    setCurrentYear(e.value);
  }, [year])

  const onUploadSuccess = useCallback((data) => {
    notify("Data uploaded succesfully.", 'success', 5000);
    setCurrentCompany(null);
    setOriginalData(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setLoading(false);
    year?navigate("/hsedata/"+year):navigate("/hsedata")
  }, [navigate, year])

  const onUploadData = useCallback((e) => {

    //el['reporting_year']=currentYear.toString();
    //el['reporting_year_identifier']=currentYear.toString()+"_"+el['Identifier'];
    //el['company_id'] = currentCompany.company_id;
    if (originalData.length > 0) {
      updateAPIReportData("/reports/data/hse", user,
        {
          company_id: currentCompany.company_id,
          reporting_year: currentYear.toString(),
          items: originalData
        }, onUploadSuccess, onError)
      setLoading(true);
    } else {
      notify("No data was uploaded.", 'warning', 5000);
      year?navigate("/hsedata/"+year):navigate("/hsedata");
    }

  }, [originalData, user, onUploadSuccess, onError, currentCompany, currentYear, navigate, year])



  if(!loading) {
    return (
      <React.Fragment>
        <div className="d-flex flex-row justify-content-between">
          <h2 className={'content-block'}>Health, Safety & Environmental Company Data Upload</h2>
          <div className="d-flex flex-row justify-content-between">
            <Button
              className="me-2"
              text="Cancel"
              stylingMode="outlined"
              type="default"
              onClick={() => {year?navigate("/hsedata/"+year):navigate("/hsedata")}}
            />
          </div>
        </div>
        <hr className="mt-0 mb-5"></hr>
        <div className={'content-block'}>
          {isAdmin && (!company_id) && <div>
          <h5 className="mt-3"> Choose the company you want to upload the data for</h5>
          <SelectBox
              dataSource={companiesList}
              showDropDownButton={true}
              activeStateEnabled={true}
              searchEnabled={true}
              valueExpr='company_id'
              displayExpr='company_name'
              onValueChanged={onCompanySelected}
              value={currentCompany?.company_id}
          >
          </SelectBox>
          </div>

          }
          {isAdmin && company_id && <h5 className="mt-3"> Company: {currentCompany?.company_name}</h5>}
          {isAdmin && year && <h5 className="mt-3 mb-5"> Reporting year: {currentYear}</h5>}
          {isAdmin && (!year) && <div>
          <h5 className="mt-3"> Choose the reporting year</h5>
          <SelectBox
              dataSource={yearsList}
              showDropDownButton={true}
              activeStateEnabled={true}
              onValueChanged={onYearSelected}
              value={currentYear}
          >
          </SelectBox>
          </div>

          }

          <h5 className="mt-3">Copy-Paste your data </h5>
          <p>Make sure that all calculations are in place (identifier 73 or greater). Copy all your data, including the first row, from the HSE Survey Template and then press Paste Data below.</p>
          <Button
            text="Paste Data"
            className="me-2"
            stylingMode="outlined"
            type="default"
            disabled={currentCompany === null}
            onClick={readClipboard}
          />
          {false && <Button
            text="Upload tab separated values file"
            stylingMode="outlined"
            type="default"
            disabled={currentCompany === null}
            onClick={()=>fileInputRef.current.click()}
          />}
        </div>
        {originalData && <div className={'content-block'}>
          <h5>Review your data and upload</h5>
          <p>If you have to change the data go back to your excel template, make the necessary changes and repeat step 2. When all your data looks good press Upload Data below.</p>
          <Button
            className="mb-3"
            text="Upload Data"
            type="danger"
            onClick={onUploadData}
          />

          <DataGrid id="dataGrid"
            dataSource={originalData}
            columnHidingEnabled={false}
            cellHintEnabled={true}
            wordWrapEnabled={true}
          >

            <Column
              dataField={'Identifier'}
              visibleIndex={0}
              dataType="number"
              width="100px"
            >
            </Column>
            <Column
              dataField={'Category'}
              visibleIndex={1}
              width="120px"
            >
            </Column>
            <Column
              dataField={'Subcategory'}
              visibleIndex={2}
              width="200px"
            >
            </Column>
            <Column
              dataField={'Details'}
              visibleIndex={3}
              width="350px"
            >
            </Column>
            <Column
              dataField={"year_"+(currentYear-2).toString()}
              visibleIndex={4}
              width="120px"
            >
            </Column>
            <Column
              dataField={"year_"+(currentYear-1).toString()}
              visibleIndex={5}
              width="120px"
            >
            </Column>
            <Column
              dataField={"year_"+currentYear.toString()}
              visibleIndex={6}
              width="120px"
            >
            </Column>

            <Paging defaultPageSize={200} />
          </DataGrid>
        </div>}
      </React.Fragment>
    )
  } else {
    return (
      <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
          <LoadIndicator
              id="large-indicator"
              height={60}
              width={60}
          />
      </div>
    )
  }

}
